import { getClassNames } from '@sprd/sprd-component-kit/v2';

export type ProgressClassNameProps = {
  root?: string;
  progress?: string;
};

type ProgressBarProps = {
  progress: number;
  background?: 'white' | 'gray' | 'black';
  className?: string | ProgressClassNameProps;
  isVisible?: boolean;
};

export default function ProgressBar({
  progress,
  background = 'white',
  className = '',
  isVisible = true,
}: ProgressBarProps) {
  const progressBarColor = background === 'black' ? 'bg-white' : 'bg-black';
  const progressBarBg = background === 'black' ? 'bg-gray-400' : 'bg-gray-200';
  const percentage = Math.round(progress * 100);

  if (!isVisible) return null;

  const classNames = getClassNames(className);

  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={percentage}
      aria-label="Progress"
      className={`mt-8 hidden h-1 md:block ${progressBarBg} md:mt-12 ${classNames.root}`}
    >
      <div
        className={`h-full ${progressBarColor} transition-all duration-300 ${classNames.progress}`}
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
}
